'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Input2 = require('./Input');

var _Input3 = _interopRequireDefault(_Input2);

var _Typography = require('../Typography');

var _Typography2 = _interopRequireDefault(_Typography);

var _Input4 = require('./Input.scss');

var _Input5 = _interopRequireDefault(_Input4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThemedInput = function (_Input) {
  _inherits(ThemedInput, _Input);

  function ThemedInput() {
    _classCallCheck(this, ThemedInput);

    return _possibleConstructorReturn(this, (ThemedInput.__proto__ || Object.getPrototypeOf(ThemedInput)).apply(this, arguments));
  }

  _createClass(ThemedInput, [{
    key: 'render',
    value: function render() {
      var _classes;

      var _props = this.props,
          id = _props.id,
          size = _props.size,
          dataHook = _props.dataHook,
          title = _props.title,
          theme = _props.theme,
          rtl = _props.rtl,
          disabled = _props.disabled,
          error = _props.error,
          forceHover = _props.forceHover,
          forceFocus = _props.forceFocus,
          roundInput = _props.roundInput,
          noLeftBorderRadius = _props.noLeftBorderRadius,
          noRightBorderRadius = _props.noRightBorderRadius,
          value = _props.value,
          withSelection = _props.withSelection;


      var classes = (_classes = {}, _defineProperty(_classes, _Input5.default.rtl, !!rtl), _defineProperty(_classes, _Input5.default.disabled, disabled), _defineProperty(_classes, _Input5.default.hasError, !!error), _defineProperty(_classes, _Input5.default.hasHover, forceHover), _defineProperty(_classes, _Input5.default.hasFocus, forceFocus || this.state.focus), _defineProperty(_classes, _Input5.default.roundInput, roundInput), _defineProperty(_classes, _Input5.default.hasValue, value && value.length || this.input && !!this.input.value), _defineProperty(_classes, noRightBorderRadius, noRightBorderRadius), _defineProperty(_classes, noLeftBorderRadius, noLeftBorderRadius), _classes);

      var placeholder = this.props.placeholder;
      return _react2.default.createElement(
        'div',
        {
          className: (0, _classnames2.default)(classes, _Input5.default.root, _Input5.default['theme-' + theme], _Input5.default['size-' + size + (withSelection ? '-with-selection' : '')]),
          'data-hook': dataHook
        },
        theme === 'amaterial' && _react2.default.createElement(
          'label',
          { className: (0, _classnames2.default)(_Input5.default.materialTitle, _Typography2.default.t1_1), htmlFor: id },
          title
        ),
        _get(ThemedInput.prototype.__proto__ || Object.getPrototypeOf(ThemedInput.prototype), 'render', this).call(this, { placeholder: placeholder }),
        theme === 'material' && _react2.default.createElement('div', { className: _Input5.default.bar + ' ' + _Input5.default.barBlack }),
        theme === 'amaterial' && _react2.default.createElement('div', { className: _Input5.default.bar + ' ' + _Input5.default.barBlue })
      );
    }
  }]);

  return ThemedInput;
}(_Input3.default);

exports.default = ThemedInput;